import { render, staticRenderFns } from "./statisticalSummary.vue?vue&type=template&id=21b141cc&scoped=true"
import script from "./statisticalSummary.vue?vue&type=script&lang=js"
export * from "./statisticalSummary.vue?vue&type=script&lang=js"
import style0 from "./statisticalSummary.vue?vue&type=style&index=0&id=21b141cc&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21b141cc",
  null
  
)

export default component.exports